<div class="modal-container">
  <span class="col-2 d-flex cross-container close-button">
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor"
      (click)="closeDialog()"
    />
  </span>

  <div>
    <h2>{{ "Resend_Invitaion" | translate }}</h2>
    <p>{{ "INVITATION_RESENT_TO_EMAIL" | translate }}<br />
      <strong>{{ email }}</strong>
    </p>
  </div>

  <div class="buttons-wrapper">
    <button class="btn btn-danger px-3 w-100 btn-submit" (click)="resend()"> {{ "RESEND_INVITATION" | translate }} </button>
    <button class="cancel-btn" (click)="cancel()">{{ "CANCEL" | translate }}</button>
  </div>
</div>
